module.exports = __webpack_public_path__ + "static/media/perez_owen_hallauer.2dcac27f.jpg";